import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-comment-on-add-confirmation',
  templateUrl: './comment-on-add-confirmation.component.html',
  styleUrls: ['./comment-on-add-confirmation.component.scss'],

})
export class CommentOnAddConfirmationComponent {
  @Input() entity: any;

  getInvoiceCodes(invoice: any): string {
    const codes = invoice.physicalInvoices.map((inv) => inv.code) || [];
    return codes.join(", ");
  }

  getInvoiceCodesCount(invoice: any): number {
    const codes = invoice.physicalInvoices.map((inv) => inv.code) || [];
    return codes.length;
  }
}
